import {PollingBaseService} from '../../shared/models/polling-base-service.model';
import {AlertsService} from './alerts.service';
import {forwardRef, Inject, Injectable} from '@angular/core';
import {Alert} from '../models/alert.model';

@Injectable()
export class OrderAlertsDetailsPollingService extends PollingBaseService {
	private orderID: number;

	constructor(@Inject(forwardRef(() => AlertsService)) private alertsService: AlertsService) {
		super();
	}

	settingPolling(orderID: number) {
		this.orderID = orderID;
		this.stopPolling();
		this.startPolling();
	}

	doAction() {
		this.alertsService.getAlertsByOrder(this.orderID).subscribe(
			(alerts: Alert[]) => {
				this.lastResult = alerts;
				this.pollingSubject.next(this.lastResult);
			});
	}
}
